<template>
  <v-container
    fluid
    id="containerStepper"
    style="padding: 12px !important;height: 100%; padding-top: 0 !important;padding-bottom: 80px !important;"
  >
    <v-row align="center" justify="center">
      <v-col lg="6" xs="12">
        <v-row class="mb-6" no-gutters>
          <v-col lg="12">
            <h4 style="font-weight: bolder;">{{ $t("asist") }}</h4>
          </v-col>
        </v-row>
        <v-row class="mb-6" justify="center" no-gutters style="margin-bottom: 0 !important;">
          <v-col lg="2" style="display: contents;">
            <v-btn fab small dark :color="colorTheme">
              <v-icon>mdi-truck</v-icon>
            </v-btn>
          </v-col>

          <v-col style=" padding-top: 17px;" lg="3">
            <v-progress-linear :color="progressColor" height="5" value="100" width="50%"></v-progress-linear>
          </v-col>

          <v-col lg="2" style="display: contents;">
            <v-btn fab dark small :color="colorStep2">
              <v-icon>mdi-content-paste</v-icon>
            </v-btn>
          </v-col>

          <v-col style=" padding-top: 17px;" lg="3">
            <v-progress-linear :color="progressColor" height="5" value="100" width="50%"></v-progress-linear>
          </v-col>

          <v-col lg="2" style="display: contents;">
            <v-btn fab dark small :color="colorStep3">
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-col lg="12">
        <filter-vehicles :hidden="hiddeFilterV"></filter-vehicles>
        <report-details :hidden="hiddeDetails"></report-details>
        <summary-report :hidden="hiddeSummary"></summary-report>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col lg="2">
        <v-btn
          style="min-width: 130px;"
          :color="colorTheme"
          class="white--text"
          @click="backTo()"
        >{{ $t("back").toUpperCase() }}</v-btn>
      </v-col>
      <v-col lg="2">
        <v-btn
          :color="colorTheme"
          :disabled="!toContinue"
          class="white--text"
          @click="continueTo()"
          style="min-width: 130px;"
        >{{ $t("continue").toUpperCase() }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";

export default {
  name: "stepper",
  components: {
    filterVehicles: () => import("@/components/filterVehicles"),
    reportDetails: () => import("@/components/reportDetails"),
    summaryReport: () => import("@/components/summaryReport")
  },
  data() {
    return {};
  },
  computed: {
    ...mapState([
      "colorStep2",
      "colorStep3",
      "valueDeterminate",
      "styleComponent",
      "hiddeFilterV",
      "hiddeDetails",
      "hiddeSummary",
      "toContinue",
      "colorTheme",
      "progressColor"
    ]),
    errorMessage: {
      get: function() {
        return this.$store.state.errorMessage;
      },
      set: function() {
        this.$store.commit("errorMessage", false);
      }
    },
    errorMessageText: {
      get: function() {
        return this.$store.state.errorMessageText;
      },
      set: function() {}
    }
  },
  created() {
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("setPageHeader", [
      this.$t("titleRep"),
      "",
      "",
      "",
      false
    ]);
    this.$store.commit("setValuesReportsPage");
    this.$store.commit("changeTable", false);
  },
  methods: {
    continueTo() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.$store.commit("setAccount", false);
      this.$store.dispatch("reportValidations");
    },
    backTo() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      //this.$store.commit("setAccount", false);
      this.$store.commit("toBackStepper");
    }
  },
  watch: {}
};
</script>

<style scoped></style>
